import React, { useEffect, useState } from "react";
import { responseHero } from "../../../../utils/axiosInterceptor";
import { toast } from "react-toastify";
import { Group } from "../../../../models/group.model";
import { FixDepositRegister } from "../../../../models/fixdepositregister.model";

type ModalProps = {
    title: string;
    group: Group | undefined;
    showModal: boolean;
    closeModal: () => void;
    handleStateChange: () => void;
    row: FixDepositRegister | undefined;
}

const ModifyFixDepositModal = ({ group, row, title, showModal, closeModal, handleStateChange }: ModalProps) => {
    const [recordData, setRecordData] = useState({
        invested: 0,
        contractStartDate: "",
        contractEndDate: "",
        guaranteedReturn: 0,
    });

    // Amikor megnyílik vagy változik a sor, feltöltjük az inputokat
    useEffect(() => {
        if (!row) return;
        setRecordData({
            invested: row.invested || 0,
            contractStartDate: row.contractStartDate ? row.contractStartDate.toString().split('T')[0] : "",
            contractEndDate: row.contractEndDate ? row.contractEndDate.toString().split('T')[0] : "",
            guaranteedReturn: row.guaranteedReturn || 0,
        });
    }, [row, showModal]);

    const handleChange = (field: string, e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setRecordData(prev => ({
            ...prev,
            [field]: e.target.type === "number" ? (parseInt(value, 10) || 0) : value
        }));
    };

    const updateRecord = async () => {
        if (!group || !row) return;

        // Igazítva az új végponthoz / adatszerkezethez
        await responseHero.put(`${process.env.REACT_APP_API_URL}/fdr/${row.id}`, { 
            data: recordData 
        })
        .then(() => {
            closeModal();
            handleStateChange();
            toast.success("Sikeresen módosítottad a rekordot!");
        })
        .catch(error => {
            console.error(error);
            closeModal();
            toast.error("Sikertelen adatmódosítás!");
        });
    };

    return (
        <>
            {showModal && (
                <>
                <div className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                    <div className="relative w-full my-6 mx-auto max-w-2xl">
                        <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                            
                            <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t">
                                <h3 className="text-xl text-dark-blue font-semibold">{title} - {row?.user?.name}</h3>
                            </div>

                            <div className="relative p-6 flex-auto">
                                <form className="space-y-4">
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-1">Befizetett tőke (EUR)</label>
                                            <input
                                                value={recordData.invested}
                                                onChange={(e) => handleChange('invested', e)}
                                                type="number"
                                                className="shadow border rounded w-full py-2 px-3 text-gray-700 focus:outline-none"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-1">Garantált hozam (/év %)</label>
                                            <input
                                                value={recordData.guaranteedReturn}
                                                onChange={(e) => handleChange('guaranteedReturn', e)}
                                                type="number"
                                                className="shadow border rounded w-full py-2 px-3 text-gray-700 focus:outline-none"
                                            />
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-1">Szerződés indulása</label>
                                            <input
                                                value={recordData.contractStartDate}
                                                onChange={(e) => handleChange('contractStartDate', e)}
                                                type="date"
                                                className="shadow border rounded w-full py-2 px-3 text-gray-700 focus:outline-none"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-1">Szerződés lejárata</label>
                                            <input
                                                value={recordData.contractEndDate}
                                                onChange={(e) => handleChange('contractEndDate', e)}
                                                type="date"
                                                className="shadow border rounded w-full py-2 px-3 text-gray-700 focus:outline-none"
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="flex items-center justify-end p-6 border-t border-solid border-gray-200 rounded-b">
                                <button
                                    className="text-red-500 font-bold uppercase px-6 py-2 text-sm outline-none mr-1 mb-1"
                                    type="button"
                                    onClick={closeModal}
                                >
                                    Mégse
                                </button>
                                <button
                                    className="text-cream bg-dark-blue font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none mr-1 mb-1"
                                    type="button"
                                    onClick={updateRecord}
                                >
                                    Mentés
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm z-40"></div>
                </>
            )}
        </>
    );
};

export default ModifyFixDepositModal;